import { Radio as AntRadio } from 'antd';
import styled from 'styled-components';
export const Radio = styled(AntRadio)`
  .ant-radio-disabled .ant-radio-inner {
    background-color: inherit;
  }

  .ant-radio-checked .ant-radio-inner {
    box-shadow: var(--shadow-highlight)
      rgba(var(--blue-60-in-rgb), var(--shadow-highlight-color-opacity));
  }

  .ant-radio-checked.ant-radio-disabled .ant-radio-inner {
    background-color: var(--gray-20);
    box-shadow: var(--shadow-highlight)
      rgba(224, 224, 224, var(--shadow-highlight-color-opacity));
  }
`;
export const DefaultRadioGroup = styled(AntRadio.Group)``;
